import { Button } from '@savvy-wealth/savvy-kit/components/button';

import type { ButtonProps } from '@savvy-wealth/savvy-kit/components/button';
import type { TrackedClickableElementName } from '@savvy/deprecated-shared/tracking/tracked-clickable-element-name';
import { useParentElementViewContext } from '@savvy/deprecated-shared/tracking/parent-element-view-context';
import { useTrackEvent } from '@savvy/deprecated-shared/tracking/use-track-event';

export type TrackedButtonProps = {
  readonly elementName: TrackedClickableElementName;
} & ButtonProps;

function TrackedButton({ elementName, onClick, ...props }: TrackedButtonProps) {
  const trackButtonClick = useTrackEvent('userInteraction');
  const parentElementViewContext = useParentElementViewContext();
  const parentElementName = parentElementViewContext?.parentElementName;
  const parentElementType = parentElementViewContext?.parentElementType;
  return (
    <Button
      {...props}
      onClick={(event) => {
        trackButtonClick({
          elementName,
          htmlElement: 'button',
          interactionType: 'button_click',
          parentElementName,
          parentElementType,
        });
        return onClick?.(event);
      }}
    />
  );
}

export default TrackedButton;
